import { useWizard } from '../../context/WizardContext';
import { AnimatePresence } from 'framer-motion';
import { StepIndicator, StepTitle } from '../StepIndicator';
import { Step1DestinoObjetivo } from './Step1Location';
import { Step2Perfil } from './Step2Goal';
import { Step3Contato } from './Step3Family';

export const Wizard = ({ onPreviewComplete }) => {
  const { step } = useWizard();

  const renderStep = () => {
    switch (step) {
      case 1:
        return <Step1DestinoObjetivo />;
      case 2:
        return <Step2Perfil />;
      case 3:
        return <Step3Contato onPreviewComplete={onPreviewComplete} />;
      default:
        return <Step1DestinoObjetivo />;
    }
  };

  return (
    <div className="w-full max-w-lg mx-auto">
      <StepIndicator />
      <StepTitle />
      <AnimatePresence mode="wait">
        {renderStep()}
      </AnimatePresence>
    </div>
  );
};

export default Wizard;
